import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import CurrencySelector from '../../../components/CurrencySelector';
import OptionsContainer from '../../../components/OptionsContainer';
import FlexBox from '../../../../../components/FlexBox';
import DatePicker from '../../../components/DatePicker/index';
import MySelect from '../../../../../components/MySelect';
import { checkDateOnly, required } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage } from '../../../../../components/Validation';
import Select from 'react-select';
import ExpenseForSelect from '../../../components/ExpenseForSelect';

export class DescriptionOfItem extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regexNumber = /^(0*[1-9]\d*(\.\d{0,2})?|0+\.\d*[1-9]\d*)$/; // regex to check for number > 0
    let value = target.type === 'checkbox' ? target.checked : target.value;
    if (regexNumber.test(value)) {
      const item = { ...this.props.item, ...{ [propertyName]: value } };
      this.change(item);
    } else {
      value = '';
      const item = { ...this.props.item, ...{ [propertyName]: value } };
      this.change(item);
    }
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  onChangeResetReceived = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    item.fromWhom = '';
    item.howMuch = '';
    item.currencyExpensesClaimed = '';
    item.dateReimbursementReceived = '';
    this.change(item);
  };

  handleChangeInsureds = (selectedClaimFor) => {
    if (selectedClaimFor) {
      const item = { ...this.props.item, ...{ ['selectedClaimFor']: selectedClaimFor } };
      this.change(item);
    }
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  handleSelectDepreciationType = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };
  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  render() {
    const {
      disabled,
      removable,
      validatorGroup,
      validationCounter,
      insuredsList,
      isClaimForFieldEnabled,
      item,
      depreciationTypes,
      showDropdowns
    } = this.props;
    const showDepreciationType = depreciationTypes.length > 0;
    const selectedClaimForList = !!item.selectedClaimFor && typeof item.selectedClaimFor.toJS === 'function'
    ? item.selectedClaimFor.toJS()
    : item.selectedClaimFor || [];
    return (
      <div className="expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="form-group col-auto">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
          <div className="form-group col-auto">
            <PageSectionHeader>
              <FormattedMessage {...messages.itemWithIdx} values={{ idx: this.props.index + 1 }} />
            </PageSectionHeader>
          </div>
        </div>
        {isClaimForFieldEnabled === true &&
          <div className="row">
            <div className="form-group col-sm-7 col-md-7">
              <ExpenseForSelect
                validatorGroup={validatorGroup}
                validationCounter={validationCounter}
                defaultValue={selectedClaimForList}
                disabled={disabled}
                options={insuredsList}
                onChange={(v) => this.handleChangeInsureds(v)}
                value={selectedClaimForList}
                fieldName={messages.expenseFor}
                tooltipContent={messages.selectInsuredForExpense.defaultMessage}
                messages={messages}
              />
            </div>
            <div className="form-group col-sm-5 col-md-5">
            </div>
          </div>
        }
        <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.item}
              fieldName={messages.descriptionOfItems}
            >
              <Textbox
                disabled={disabled}
                name="item"
                type="text"
                onChange={this.onChange('item')}
                value={item.item}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.descriptionOfItems}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <Validate
              name="dateOfPurchase"
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required, checkDateOnly]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              defaultValue={item.dateOfPurchase}
              fieldName={messages.dateOfPurchase}
            >
              <DatePicker
                disabled={disabled}
                name="dateOfPurchase"
                type="text"
                onDayChange={this.handleDayChange('dateOfPurchase')}
                value={item.dateOfPurchase}
                placeholder="dd/mm/yyyy"
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.dateOfPurchase}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        { showDepreciationType &&
          <div className="row">
            <div className="form-group col-sm-7 col-md-7">
              <Validate
                name="depreciationType"
                validators={[required]}
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                defaultValue={item.depreciationType}
                fieldName={messages.depreciationType}
              >
                <MySelect
                  dataList={depreciationTypes}
                  name="depreciationTypes"
                  disabled={disabled}
                  onChange={this.handleSelectDepreciationType('depreciationType')}
                  value={item.depreciationType}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.depreciationType}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className="form-group col-md-5 col-sm-5">
            </div>
          </div>
        }
        {/* <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.costOfReplacement}
              fieldName={messages.costOfReplacement}
            >
              <Textbox
                disabled={disabled}
                name="costOfReplacement"
                type="number"
                onChange={this.onChangeAmount('costOfReplacement')}
                value={item.costOfReplacement}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.costOfReplacement}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.currencyCostOfReplacement}
              fieldName={messages.currency}
            >
              <CurrencySelector
                onChange={this.handleCurrencyChange('currencyCostOfReplacement')}
                disabled={disabled}
                value={item.currencyCostOfReplacement}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div> */}
        {/* <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.estimatedValue}
              fieldName={messages.originalCost}
            >
              <Textbox
                disabled={disabled}
                name="estimatedValue"
                type="number"
                onChange={this.onChangeAmount('estimatedValue')}
                value={item.estimatedValue}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.originalCost}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.currencyEstimatedValue}
              fieldName={messages.currency}
            >
              <CurrencySelector
                onChange={this.handleCurrencyChange('currencyEstimatedValue')}
                disabled={disabled}
                value={item.currencyEstimatedValue}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div> */}
        {/* using this field */}
        <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.amountClaimed}
              fieldName={messages.originalCost}
            >
              <Textbox
                disabled={disabled}
                name="amountClaimed"
                type="number"
                onChange={this.onChangeAmount('amountClaimed')}
                value={item.amountClaimed}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.originalCost}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.currentClaimed}
              fieldName={messages.currency}
            >
              <CurrencySelector
                onChange={this.handleCurrencyChange('currentClaimed')}
                disabled={disabled}
                value={item.currentClaimed}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className="row">
          <div className={'col-sm-6 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.haveYouReceivedReimbursement} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  type="radio"
                  value="true"
                  checked={item.haveYouReceivedReimbursement === 'true'}
                  onChange={this.onChangeResetReceived('haveYouReceivedReimbursement')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  type="radio"
                  value="false"
                  checked={item.haveYouReceivedReimbursement === 'false'}
                  onChange={this.onChange('haveYouReceivedReimbursement')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          <div className={'col-sm-6 form-group'}>
          </div>
        </div>
        {item.haveYouReceivedReimbursement === 'true' && (
          <div>
            <div className={'row ml-2'}>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  className="w-full"
                  defaultValue={item.fromWhom}
                  fieldName={messages.fromWhom}
                >
                  <Textbox
                    disabled={disabled}
                    name="fromWhom"
                    type="text"
                    onChange={this.onChange('fromWhom')}
                    value={item.fromWhom}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.fromWhom}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  name="dateReimbursementReceived"
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required, checkDateOnly]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  defaultValue={item.dateReimbursementReceived}
                  fieldName={messages.dateReimbursementReceived}
                >
                  <DatePicker
                    disabled={disabled}
                    name="dateReimbursementReceived"
                    type="text"
                    onDayChange={this.handleDayChange('dateReimbursementReceived')}
                    value={item.dateReimbursementReceived}
                    placeholder="dd/mm/yyyy"
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateReimbursementReceived}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateReimbursementReceived}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
              </div>
            </div>
            <div className={'row ml-2'}>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  className="w-full"
                  defaultValue={item.howMuch}
                  fieldName={messages.howMuch}
                >
                  <Textbox
                    disabled={disabled}
                    name="howMuch"
                    type="number"
                    onChange={this.onChangeAmount('howMuch')}
                    value={item.howMuch}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.howMuch}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
                <Validate
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  className="w-full"
                  defaultValue={item.currencyExpensesClaimed}
                  fieldName={messages.currency}
                >
                  <CurrencySelector
                    onChange={this.handleCurrencyChange('currencyExpensesClaimed')}
                    disabled={disabled}
                    value={item.currencyExpensesClaimed}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.currency}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-4 col-sm-4">
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

DescriptionOfItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
  depreciationTypes: PropTypes.any,
  showDropdowns: PropTypes.bool,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepBaggageAndPersonalItems/components/DescriptionOfItem/DescriptionOfItem.js